module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/5@2x_758f0dc278edac149af89c68bdebb8b2.png";